import { render, staticRenderFns } from "./AvSwitch.vue?vue&type=template&id=20e2f8fb"
import script from "./AvSwitch.vue?vue&type=script&lang=ts"
export * from "./AvSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports